// PartCPage3.jsx - Part C Page 3 for HPC Report (Pixel-perfect redesign - Stage 1 Teacher Assessment)
import React from 'react';

const PartCPage3 = ({ data }) => {
  const teacherFields = data?.teacher_fields || {};

  const calculateTotal = (category) => {
    if (!category) return 0;
    let total = 0;
    if (category.item_1) total++;
    if (category.item_2) total++;
    if (category.item_3) total++;
    if (category.custom_1_checked) total++;
    if (category.custom_2_checked) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = teacherFields[categoryName] || {};

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'black',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '10px',
          padding: '10px 12px',
          backgroundColor: '#FFE5D5',
          minHeight: '100px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: 'white'
              }}>
                {category[`item_${index + 1}`] && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          {category.custom_1 && (
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: 'white'
              }}>
                {category.custom_1_checked && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{category.custom_1}</span>
            </div>
          )}

          {category.custom_2 && (
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: 'white'
              }}>
                {category.custom_2_checked && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{category.custom_2}</span>
            </div>
          )}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(category)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Stage 1 Header */}
      <div style={{
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px'
      }}>
        Stage 1
      </div>

      {/* Teacher Assessment Label */}
      <div style={{
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '12px',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '6px 12px',
        display: 'inline-block'
      }}>
        Teacher Assessment
      </div>

      {/* Instructions */}
      <div style={{
        fontSize: '10px',
        marginBottom: '15px',
        padding: '8px 12px',
        backgroundColor: 'white',
        lineHeight: '1.5'
      }}>
        <strong>Step 1:</strong> Choose <strong>two additional parameters</strong> from pages 29-30 for <strong>Stage 1</strong>.<br />
        <strong>Step 2:</strong> Tick (✓) <strong>parameters</strong> that the learner fulfills.
      </div>

      {/* Awareness Category */}
      {renderCategory('awareness', 'Awareness', [
        'The learner has conceptual understanding.',
        'There is alignment between research problem and questionnaire.',
        'The learner has identified potential challenges.'
      ])}

      {/* Sensitivity Category */}
      {renderCategory('sensitivity', 'Sensitivity', [
        'The learner understands the larger social purpose of the task.',
        'The questionnaire has inclusive and accessible wording.',
        'There is clear understanding of who the stakeholders are and their needs/concerns.'
      ])}

      {/* Creativity Category */}
      {renderCategory('creativity', 'Creativity', [
        'The learner considers alternative methods of collecting findings.',
        'The learner considers alternative groups of respondents as a source of data.',
        'The learner thinks of different ways to motivate respondents to answer.'
      ])}

      {/* Brief comments */}
      <div style={{ marginBottom: '15px' }}>
        <div style={{
          backgroundColor: 'white',
          padding: '6px 0',
          fontWeight: 'bold',
          fontSize: '10px',
          marginBottom: '8px'
        }}>
          Brief comments and pedagogical interventions recommended:
        </div>
        <div style={{
          padding: '10px 12px',
          fontSize: '10px',
          minHeight: '60px',
          backgroundColor: '#FFE5D5',
          lineHeight: '1.4'
        }}>
          {teacherFields.brief_comments || ''}
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        21
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartCPage3;
